import { MailOutline } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import topicsBackground from "../assets/images/topics_background.svg";
import p4lLogo from "../assets/logo/PfL Logo no words 2023-11-21-01.png";
import Button from "../componentLibrary/Button";

const VerificationSentPage = () => {
  const location = useLocation();
  const userEmail = location.state?.email || "your email";

  return (
    <div className="min-h-screen relative pb-6 bg-gradient-to-b from-electrum-100 via-white to-white">
      <div
        className="fixed inset-0 z-0 top-8"
        style={{
          backgroundImage: `url(${topicsBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      />

      <div className="relative z-10">
        <div className="flex flex-col mx-auto w-full max-w-md px-4 pt-16 space-y-6">
          <div className="bg-white/90 backdrop-blur-sm rounded-lg shadow-lg p-8">
            <div className="flex flex-col items-center mb-8">
              <img
                src={p4lLogo}
                alt="Psych For Life logo"
                className="w-32 h-32 mb-2"
              />
              <p className="text-gray-900 text-3xl">Psych For Life&reg;</p>
            </div>

            <div className="flex flex-col items-center text-center mb-8">
              <div className="mb-4 bg-blue-50 rounded-full p-4">
                <MailOutline className="text-blue-600 w-16 h-16" />
              </div>

              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                Check Your Email
              </h1>

              <p className="text-gray-600 mb-4 leading-relaxed">
                We&apos;ve sent a verification link to
              </p>

              <p className="text-blue-600 font-semibold mb-4">{userEmail}</p>

              <p className="text-gray-600 text-sm leading-relaxed">
                Click the link in the email to verify your account and complete
                your registration.
              </p>
            </div>

            <div className="text-center mb-4">
              <p className="text-gray-700 font-medium mb-2">
                Already verified your email?
              </p>
              <p className="text-sm text-gray-600">
                Sign in to access your account
              </p>
            </div>

            <Link to="/login">
              <Button
                variant="secondary"
                className="w-full border-2 border-blue-300 text-blue-700 hover:bg-blue-50 py-3 rounded-lg font-semibold transition-colors duration-200 mb-4"
              >
                Go to Login
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationSentPage;
